import createRootReducer from './root-reducer';
import { createConfigureStore } from '../../shared/configure-store';
export default createConfigureStore({
    createRootReducer: createRootReducer,
    createRootReducerPath: require.resolve('./root-reducer'),
});
